//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/FacetCollector.js";
import "../no/SelectDisplayableObjectList.js";
import "../Mfg/Mfg.AM.Sketcher.js";
import "../no/FacetCollector.js";
import "../no/Mfg.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BodySelection",0,"SelectNXObjectList",0],[1,"CurveSelection",0,"ScCollector",0],[1,"FaceSelection",0,"ScCollector",0],[1,"FacetCollector",0,"FacetCollector",0],[0,"Mode",1,0],[1,"PartSelection",0,"SelectDisplayableObjectList",0],[0,"PlatformFilter",1,0],[1,"PointSelection",0,"SelectNXObjectList",0],[1,"Sketcher",0,"Mfg.AM.Sketcher",0],[0,"SupportProfile",1,"Mfg.AM.SupportProfile",0],[0,"SupportType",1,0],[0,"Type",1,1]],[[["faces"],"SetSurfaceRegion",{},1,0],[["tagProfile"],"SetProfileSupport",{},1,0],[[],"GetProfileSupport",{R_:{tagProfile:"Mfg.AM.ProfileSupport"}},0,0]],[]];
SPLM.Mfg.AM.SupportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.SupportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mfg.AM.SupportBuilder.Types = Object.freeze({
    "Block" : "Block", "Line" : "Line", "Point" : "Point", "Nosupport" : "Nosupport", "UserDefined" : "UserDefined", "Volume" : "Volume", "Web" : "Web", "Contour" : "Contour", "Gusset" : "Gusset", "Combined" : "Combined", "Tree" : "Tree", "Hybrid" : "Hybrid"});

SPLM.Mfg.AM.SupportBuilder.Modes = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual", "RegionsOnly" : "RegionsOnly", "Duplicate" : "Duplicate"});

SPLM.Mfg.AM.SupportBuilder.PlatformFilterMode = Object.freeze({
    "KeepAll" : "KeepAll", "FullContactOnly" : "FullContactOnly", "PartitialTouch" : "PartitialTouch", "KeepPlatformFraction" : "KeepPlatformFraction", "AvoidInternal" : "AvoidInternal"});

export default SPLM;